<template>
  <div id="search-view">
    <!-- <p class="content">{{ content }}</p> -->
    <div class="search-box">
      <slot name="search"></slot>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "search-view",
  props: {
    content: String,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
#search-view {
  position: sticky;
  top: 0;
  z-index: 99;
  width: 100%;
  min-height: 50px;
  background: #fff;
  border-top: 1px solid rgba(0, 21, 41, 0.12);
  box-shadow: 0px 2px 4px 0px rgba(0, 21, 41, 0.12);
  .content {
    height: 28px;
    font-size: 17px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 28px;
    padding: 12px 20px 8px 20px;
  }

  .search-box {
    @extend .flex-align;
    position: relative;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 20px 24px 0px 24px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/searchView.vue